import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import Modal from '../Modal';
import Input from '../InputDebounced';
import { cssBEM } from './constants';
import {useCardBuilderContext} from './CardBuilder';

/* eslint-disable react/prop-types */
const CardModal = (props) => {
  const {
    activeCard,
    closeModalBtn = <span>x</span>,
    onClose,
    onSave,
    nodeId = 'root',
    renderModalHeaderFn,
    renderModalBodyFn,
    renderQuestion,
    renderOptions,
    searchCallbackFn,
    searchInputLabel,
    searchInputPlaceholder,
    showSearchFilter,
    theme
  } = props;
  const { builderKey, MessageComponent } = useCardBuilderContext();
  const modalCssBem = 'cardBuilderModal';
  const classes = classnames(modalCssBem, {
    [`${modalCssBem}--select-option-mode`]: !activeCard,
    [`${modalCssBem}--edit-option-mode`]: activeCard,
  });

  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (value) => {
    setSearchTerm(value);
    searchCallbackFn(value);
  };

  const renderHeader = () => {
    const defaultRender = (
      <>
        <MessageComponent id={ activeCard ? `${activeCard.id}.cardBuilder.title` : `${builderKey}cardBuilder.modal.title` } />
        {activeCard && (
          <div className={`${modalCssBem}__subtitle`}>
            <MessageComponent id={`${activeCard.id}.cardBuilder.subtitle`} shouldHideIfNotFound={true} />
          </div>
        )}
      </>
    );
    return renderModalHeaderFn
      ? renderModalHeaderFn(activeCard)
      : defaultRender;
  };

  const renderBody = () => {
    return renderModalBodyFn ? renderModalBodyFn(activeCard) : null;
  };

  const renderSearch = () => {
    return (
      <div className="cardBuilderModal__search-filter">
        <label htmlFor="card-search">{searchInputLabel}</label>
        <Input
          id={'card-search'}
          type={'text'}
          onChange={handleChange}
          delay={300}
          placeholder={searchInputPlaceholder}
          value={searchTerm}
        />
      </div>
    );
  };

  const renderFooter = () => {
    const btnClass = activeCard
      ? `${cssBEM}__btn--saveCard`
      : `${cssBEM}__btn--cancelEdit`;
    const btnMessageId = activeCard
      ? `${builderKey}cardBuilder.saveCard`
      : `${builderKey}cardBuilder.cancelEdit`;
    return (
      <button
        type="button"
        className={`${cssBEM}__btn ${btnClass}`}
        onClick={onSave}
        role="button"
        aria-label="Save or Edit Card"
      >
        <MessageComponent id={btnMessageId} />
      </button>
    );
  };

  useEffect(() => {
    //force modal to the top of question div when card is actively selected
    const questionsEl = document.getElementsByClassName(`${modalCssBem}__questions`);
    if(questionsEl && activeCard?.id){
      for(let x = 0; x < questionsEl.length; x++){
        questionsEl[x].scrollTop = 0;
      }
    }
  }, [activeCard?.id]);

  return (
    <Modal
      className={`${cssBEM}__modal ${theme ? ` ${theme}` : ''}`}
      closeBtn={closeModalBtn}
      nodeId={nodeId}
      onClose={onClose}
      show
    >
      <div className={classes}>
        <div className={`${modalCssBem}__header`}>
          {renderHeader()}
          {!activeCard && showSearchFilter ? renderSearch() : null}
        </div>
        <div className={`${modalCssBem}__questions`}>
          {activeCard
            ? activeCard.questions.map((question) => renderQuestion(question))
            : renderOptions()}
        </div>
        <div className={`${modalCssBem}__body`}>{renderBody()}</div>
        <div className={`${modalCssBem}__footer`}>{renderFooter()}</div>
      </div>
    </Modal>
  );
};

export default CardModal;
